import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Data_getInstance25ky60vn7g970 as Data_getInstance } from './adapter/GrantSlackAccessMutation_ResponseAdapter.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { GrantSlackAccessMutation_VariablesAdapter_instance2fh8wjvbv6izy as GrantSlackAccessMutation_VariablesAdapter_instance } from './adapter/GrantSlackAccessMutation_VariablesAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(grantSlackAccess) {
        this.j6g_1 = grantSlackAccess;
      }
      toString() {
        return 'Data(grantSlackAccess=' + this.j6g_1 + ')';
      }
      hashCode() {
        return this.j6g_1 == null ? 0 : getBooleanHashCode(this.j6g_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.j6g_1 == other.j6g_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.k6g_1 = 'e874514c291f1d673c3b491e79bafcaaf1514da74fdcb9851c57b44e01a26f89';
        this.l6g_1 = 'grantSlackAccess';
      }
      a6f() {
        return 'mutation grantSlackAccess($input: GrantSlackAccessInput!) { grantSlackAccess(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var GrantSlackAccessMutationClass;
function GrantSlackAccessMutation() {
  if (GrantSlackAccessMutationClass === VOID) {
    class $ {
      constructor(input) {
        this.m6g_1 = input;
      }
      c6f() {
        return 'e874514c291f1d673c3b491e79bafcaaf1514da74fdcb9851c57b44e01a26f89';
      }
      operationId() {
        return this.c6f();
      }
      u47() {
        return Companion_instance.a6f();
      }
      d6f() {
        return 'grantSlackAccess';
      }
      operationName() {
        return this.d6f();
      }
      o46(writer, customScalarAdapters, withDefaultValues) {
        GrantSlackAccessMutation_VariablesAdapter_instance.n6g(writer, this, customScalarAdapters, withDefaultValues);
      }
      n46() {
        return obj(Data_getInstance());
      }
      toString() {
        return 'GrantSlackAccessMutation(input=' + this.m6g_1.toString() + ')';
      }
      hashCode() {
        return this.m6g_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GrantSlackAccessMutation()))
          return false;
        if (!this.m6g_1.equals(other.m6g_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'GrantSlackAccessMutation', VOID, VOID, [Mutation()]);
    GrantSlackAccessMutationClass = $;
  }
  return GrantSlackAccessMutationClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Data as Data1rorqhenzwzbc,
  GrantSlackAccessMutation as GrantSlackAccessMutationfs5xfcp7iisz,
};
//endregion

//# sourceMappingURL=GrantSlackAccessMutation.mjs.map
